// extracted by mini-css-extract-plugin
export default {"card":"hZ-z","carouselContainer":"iZ-z","carouselContent":"jZ-z"};